module.exports = (app) => app.config(/* @ngInject */ function($mdThemingProvider) {

    $mdThemingProvider.definePalette('eprocPrimary', {
        '50': 'e7eff6',
        '100': 'c2d7e9',
        '200': '99bddb',
        '300': '70a2cd',
        '400': '528ec2',
        '500': '337ab7',
        '600': '2e72b0',
        '700': '2767a7',
        '800': '205d9f',
        '900': '144a90',
        'A100': 'c4dcff',
        'A200': '91bdff',
        'A400': '5e9eff',
        'A700': '458fff',
        'contrastDefaultColor': 'light',
        'contrastDarkColors': [
            '50',
            '100',
            '200',
            '300',
            '400',
            'A100',
            'A200',
            'A400',
            'A700'
        ],
        'contrastLightColors': [
            '500',
            '600',
            '700',
            '800',
            '900'
        ]
    });

    $mdThemingProvider.definePalette('eprocAccent', {
        '50': 'e0e0e0',
        '100': 'b3b3b3',
        '200': '808080',
        '300': '4d4d4d',
        '400': '262626',
        '500': '000000',
        '600': '000000',
        '700': '000000',
        '800': '000000',
        '900': '000000',
        'A100': 'a6a6a6',
        'A200': '8c8c8c',
        'A400': '737373',
        'A700': '666666',
        'contrastDefaultColor': 'light',
        'contrastDarkColors': [
            '50',
            '100',
            '200',
            'A100',
            'A200'
        ],
        'contrastLightColors': [
            '300',
            '400',
            '500',
            '600',
            '700',
            '800',
            '900',
            'A400',
            'A700'
        ]
    });

    $mdThemingProvider.definePalette('eprocWarn', {
        '50': 'faeaea',
        '100': 'f4cbca',
        '200': 'eca9a7',
        '300': 'e48784',
        '400': 'df6d69',
        '500': 'd9534f',
        '600': 'd54c48',
        '700': 'cf423f',
        '800': 'ca3936',
        '900': 'c02926',
        'A100': 'fffdfd',
        'A200': 'ffcbca',
        'A400': 'ff9997',
        'A700': 'ff807e',
        'contrastDefaultColor': 'light',
        'contrastDarkColors': [
            '50',
            '100',
            '200',
            '300',
            '400',
            'A100',
            'A200',
            'A400',
            'A700'
        ],
        'contrastLightColors': [
            '500',
            '600',
            '700',
            '800',
            '900'
        ]
    });

    $mdThemingProvider.theme('default')
        .primaryPalette('eprocPrimary')
        .accentPalette('eprocAccent')
        .warnPalette('eprocWarn');
});